import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  searchSlide: {
    method: 'GET',
    url: `${configs.baseUrl}/api/search/slide/`,
  },
  searchPresentation: {
    method: 'GET',
    url: `${configs.baseUrl}/api/search/presentation/`,
  },
  getTotalResult: {
    method: 'GET',
    url: `${configs.baseUrl}/api/search/global/`,
  },
  searchPresentationV2: {
    method: 'GET',
    url: `${configs.baseUrl}/api/templates/search/`,
  },

}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const searchSlide = (params) => {
  return resource.searchSlide(params)
}

const searchPresentation = (params) => {
  return resource.searchPresentation(params)
}

const searchPresentationV2 = (params) => {
  return resource.searchPresentationV2(params)
}

const getTotalResult = (params) => {
  return resource.getTotalResult(params)
}

const searchPresentations = (params, useV2 = false) => {
  return useV2 ?
    resource.searchPresentationV2(params) :
    resource.searchPresentation(params)
}

export default {
  initResource,
  searchSlide,
  searchPresentation,
  searchPresentationV2,
  searchPresentations,
  getTotalResult,
}
